
import { useEffect, useState } from "react";

import { Button } from 'primereact/button';

import { buscarPeloCodigo, handleImportarObrigacaoCertidao } from "../../service/ValidaCertidaoLegada";

import { useHistory, useParams } from "react-router-dom";

import CardSeplag from "../../components/CardSeplag";

import "./style.css";

import { CertidaoViewBeneficiario } from "./certidaoViewBeneficiario";
import { CertidaoViewDadosCertidao } from "./certidaoViewDadosCertidao";

import { printToast } from '../../config/global'
import { Dialog } from 'primereact/dialog';

const Certidao = () => {

    const [certidao, setCertidao] = useState(null);
    const [isValidado, setIsValidado] = useState(false)
    const [perguntaIR, setPerguntaIR] = useState(false)

    const history = useHistory();
    const { id } = useParams();

    useEffect(() => {

        buscarPeloCodigo(id).then(res => {
            setCertidao(res)
        })
    }, []);

    useEffect(() => {
        certidao && setIsValidado(
            certidao.tipoCertidaoValidada &&
            certidao.amparoLegalObrigacao &&
            certidao.orgao &&
            certidao.pessoa != null &&
            certidao.flagObrigacao != 'S'
        )
    }, [certidao])

    const voltar = () => {
        history.push("/listaCertidao")
    };

    const finalizarValidacao = (descontoIsIR) => {
        handleImportarObrigacaoCertidao(id, descontoIsIR).then(res => {
            printToast({ summary: "Operação realiza com sucesso", detail: "A certidão legada foi importada com sucesso no sistema " });
            history.push("/listaCertidao")
        })
    }

    function formataDinheiro(n) {
        if (n) {
            return "R$ " + n.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
        } else {
            return "Não Informado"
        }
    }

    const handleModalIr = () => {
        if (certidao.valrDesconto == 0 || certidao.valrHonAdv == 0) {
            finalizarValidacao(false);
        } else {
            setPerguntaIR(true);
        }
    }

    const renderFooter = () => {
        return <div>
            <Button label="Sim, é IR" icon="pi pi-check" onClick={() => finalizarValidacao(true)} autoFocus />
            <Button label="Não é IR" icon="pi pi-times" onClick={() => finalizarValidacao(false)} className="p-button-raised  p-button-text" />
            <Button label="Fechar" icon="pi pi-times" onClick={() => setPerguntaIR(false)} className="p-button-danger p-button-text" />
        </div>
    }
    return (
        <>
            {
                certidao &&
                <>
                    <CertidaoViewBeneficiario certidao={{ ...certidao }} setCertidao={setCertidao} />
                    <br />
                    <CertidaoViewDadosCertidao certidao={{ ...certidao }} setCertidao={setCertidao} />
                </>
            }

            <CardSeplag>
                <Button type="button" label="Voltar" icon="pi pi-arrow-left" className='botaoValidarCertidao' onClick={() => voltar()} />
                {
                    isValidado && <Button type="button" label="Finalizar Validação" icon="pi pi-check" className='p-button-success botaoValidarCertidao' onClick={() => handleModalIr()} />
                }
            </CardSeplag>

            {
                perguntaIR &&
                <Dialog
                    header="Confirmar IR"
                    visible={perguntaIR}
                    footer={renderFooter()}
                    onHide={setPerguntaIR(false)}
                >
                    <p>O valor de desconto da certidão é <strong>{certidao.valrDesconto}</strong> e o valor Honorário de advocatícios é <strong>{certidao.valrHonAdv}</strong>. Com base nessas informações confirma que o valor IR é de <strong>{certidao.valrDesconto - certidao.valrHonAdv}</strong> ?</p>
                </Dialog>
            }
        </>
    )
}


export default Certidao;

